module.exports = __webpack_public_path__ + "img/birch-dummy-logo.b30c5747.png";